var r=(o,t,n)=>{if(t&&o&&o.length!==0)for(let s of o)s[t]=n};export{r as a};
//# sourceMappingURL=chunk.P3U44LCP.js.map
